
import { Options } from "vue-class-component";
import BaseTag from "../BaseTag.vue";
@Options({
  name: "IziGrid",
  props: ["class", "padding", "margin", "height"]
})
export default class IziGrid extends BaseTag {}
